import { ReactElement } from "react";

import SignInLayout from "@/components/Layouts/SignInLayout";
import { PasswordReset } from "@/components/PasswordReset/common";
import Head from "next/head";

const PasswordResetPage = (props) => {
  return (
    <SignInLayout>
      <Head>
        <title>Reset Password</title>
      </Head>
      <PasswordReset />
    </SignInLayout>
  );
};

export default PasswordResetPage;
